// Precision Mandate (operator order 2026-11-04): on a memo, the actions
// assigned to the person looking come first, numbered from 1, then everyone
// else's actions in file order. The file order (position) never changes;
// only what each person sees is reordered and renumbered.
export function orderActionsForViewer(actions, meId) {
  const list = Array.isArray(actions) ? actions : [];
  const isMine = (a) => !!meId && (a.assignees || []).some((x) => x.user_id === meId);
  const byPosition = (a, b) => (a.position ?? 0) - (b.position ?? 0);
  const mine = list.filter(isMine).sort(byPosition);
  const rest = list.filter((a) => !isMine(a)).sort(byPosition);
  return [...mine, ...rest].map((a, i) => ({ ...a, n: i + 1, mine: isMine(a) }));
}
